import React from 'react';
import ServiceCodeHandlerInfo from "../serviceRequestCode/serviceRequestGroupCode/subpage/ServiceCodeHandlerInfo";
import GroupCodeAssetEditor from "./GroupCodeAssetEditor";
import GroupCodeServiceEditor from "./GroupCodeServiceEditor";

function GroupCodeEditorEmpty() {
    return (
        <div className="code-editor-empty">
            <div className="code-editor-empty__icon">⌘</div>
            <p className="code-editor-empty__title">코드를 선택하세요</p>
            <p className="code-editor-empty__desc">왼쪽 목록에서 코드를 선택하면 이곳에서 편집할 수 있습니다.</p>
        </div>
    );
}

function GroupCodeEditor({
    categoryKind,
    assetCodeType,
    nameLabel,
    supportsApprovalLines = false,
    supportsApprovalBeforeOnly = false,
    supportsChildCodes = true,
    code,
    setCode,
    onUpdate,
    onDelete,
    onCreateChild,
    onUpdateChild,
    onDeleteChild,
    serviceSubNav,
    groupFields,
    setFieldFlag,
}) {
    if (!code?.id) {
        return <GroupCodeEditorEmpty />;
    }

    if (categoryKind === "service") {
        if (serviceSubNav === "handler") {
            return (
                <div className="code-editor code-editor--wide group-code-handler-editor">
                    <ServiceCodeHandlerInfo serviceCode={code} />
                </div>
            );
        }
        return (
            <GroupCodeServiceEditor
                code={code}
                setCode={setCode}
                onUpdate={onUpdate}
                onDelete={onDelete}
                onCreateChild={onCreateChild}
                onUpdateChild={onUpdateChild}
                onDeleteChild={onDeleteChild}
            />
        );
    }

    return (
        <GroupCodeAssetEditor
            assetCodeType={assetCodeType}
            nameLabel={nameLabel}
            supportsApprovalLines={supportsApprovalLines}
            supportsApprovalBeforeOnly={supportsApprovalBeforeOnly}
            supportsChildCodes={supportsChildCodes}
            code={code}
            setCode={setCode}
            onUpdate={onUpdate}
            onDelete={onDelete}
            onCreateChild={onCreateChild}
            onUpdateChild={onUpdateChild}
            onDeleteChild={onDeleteChild}
            groupFields={groupFields}
            setFieldFlag={setFieldFlag}
        />
    );
}

export default GroupCodeEditor;
